import { useTranslation } from 'react-i18next'
import { useFormatNumber } from './useFormatNumber'

export const useFormatAmount = () => {
  const { i18n } = useTranslation()
  const currentLocale = i18n.resolvedLanguage || i18n.language
  const formatNumber = useFormatNumber()

  return (value: number | null | undefined, currency: string, fallback = '--', options?: Intl.NumberFormatOptions) => {
    try {
      return formatNumber(value, fallback, {
        maximumFractionDigits: 0,
        style: 'currency',
        ...options,
        currency
      })
    } catch {
      if (typeof value !== 'number' || !Number.isFinite(value)) {
        return fallback
      }

      return `${value.toLocaleString(currentLocale, { maximumFractionDigits: 0, ...options })} ${currency}`
    }
  }
}
